/**
 * This is the forgotten data service.
 * @memberOf Forgotten Module
 * @namespace Forgotten Data Service
 */

/**
 * @name ForgottenDataService
 * @desc Create the data service.
 * @param $q
 * @param $http
 * @param coreService
 * @memberOf Forgotten Module.Forgotten Data Service
 * @ngInject
 */
var forgottenDataFactory = function ($q, $http, coreService) {
    // Create the service.
    var service = {};
    return service;
}

export default forgottenDataFactory;



// WEBPACK FOOTER //
// ./src/login/forgotten/forgotten.data.service.js